import { defineStore } from 'pinia';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
import { flatTree } from '@blade-sxp/screen/utils/index';
import { zoneTreeApi } from '@blade/common/api/zone-tree';
const API = {
    zoneTreeApi
};
let alarmWS;
let realTimeWs;
let timer;
export const useMapStore = defineStore('map', {
    state: () => {
        return {
            rootId: '',
            zoneId: '',
            mapData: {},
            treeMap: {},
            isGisMap: false,
            mapDetail: {},
            parentZoneId: '',
            wsAlarmUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_MSG_WS : `wss://${window.location.host}/${process.env.VUE_APP_MSG_WS}`,
            wsRealTimeUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_REALTIME_WS : `wss://${window.location.host}/${process.env.VUE_APP_REALTIME_WS}`,
            alarmWsMsg: {},
            realTimeWsMsg: {},
            stMap: '',
            snapTime: '',
            secondTimer: false,
            timeCount: 0,
            minuteTimer: false,
            mapClick: false,
            queueAndCamAlarmPushList: {},
            sysWeather: 'sunny' // 系统天气
        };
    },
    getters: {},
    actions: {
        init() {
            this.fetchZoneTree();
            this.initTimer();
            this.initWebSocket();
        },
        async fetchZoneTree() {
            const { data, status } = await API.zoneTreeApi({});
            if (!(status === 200 && data.success))
                return;
            const tree = data.data;
            this.updateTreeMap(tree);
            this.updateRootId(tree.id);
            this.updateGisType(tree.mapType);
            if (tree.parentId && tree.parentId === '0') {
                this.parentZoneId = tree.id;
            }
        },
        initWebSocket() {
            this.initAlarmWebSocket();
            this.initRealTimeWebSocket();
        },
        initAlarmWebSocket() {
            alarmWS = new AlarmWebsocket(this.wsAlarmUrl);
            alarmWS.setOnMessage((e) => {
                try {
                    this.alarmWsMsg = JSON.parse(e.data);
                }
                catch (_) {
                    this.alarmWsMsg = e.data;
                }
            });
        },
        initRealTimeWebSocket() {
            realTimeWs = new AlarmWebsocket(this.wsRealTimeUrl);
            realTimeWs.setOnMessage((e) => {
                try {
                    this.realTimeWsMsg = JSON.parse(e.data);
                }
                catch (_) {
                    this.realTimeWsMsg = e.data;
                }
            });
        },
        closeAllWebSockets() {
            alarmWS?.close();
            realTimeWs?.close();
        },
        updateRootId(id) {
            this.rootId = id;
            this.zoneId = id;
        },
        updateTreeMap(tree) {
            this.treeMap = flatTree(tree);
        },
        updateGisType(type) {
            this.isGisMap = type === 'GIS';
        },
        initTimer() {
            timer = window.setInterval(() => {
                this.timeCount++;
                this.secondTimer = !this.secondTimer;
                if (!(this.timeCount % 60)) {
                    this.timeCount = 0;
                    this.minuteTimer = !this.minuteTimer;
                }
            }, 1000);
        },
        clearTimer() {
            timer && clearInterval(timer);
        },
        updateTimeCount() {
            this.timeCount = 0;
        },
        updateMapClick() {
            this.mapClick = !this.mapClick;
        },
    }
});
